import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

type CreateTaskVariables = { type: "PodajStany"; codes: string[] };

export const useCreateTask = (
  options?: UseMutationOptions<any, Error, CreateTaskVariables>
) => {
  return useMutation({
    ...options,
    mutationKey: ["createSubiektTask"],
    mutationFn: async (variables: CreateTaskVariables) => {
      return axiosInstance
        .post("/subiekt/tasks", variables)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Dodawanie zadania...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "create-subiekt-task",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      const connector = data?.connector;
      const isConnectorDown =
        !connector?.online || connector?.sferaConnected === false;
      Toast({
        message: isConnectorDown
          ? `Dodano zadanie nr ${data?.task?.id}, ale konektor Subiekta nie odpowiada - wynik pojawi się, gdy wróci.`
          : `Dodano zadanie nr ${data?.task?.id} - wynik pojawi się w ciągu około minuty.`,
        type: isConnectorDown
          ? TOAST_TYPES_ENUM.ERROR
          : TOAST_TYPES_ENUM.SUCCESS,
        id: "create-subiekt-task",
      });
      queryClient.invalidateQueries({ queryKey: ["subiektTasks"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      Toast({
        message: error?.data?.message || "Błąd podczas dodawania zadania.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "create-subiekt-task",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useCreateTask;
